const passArg = (state: any, id: string) => id;

export default passArg;
